import { ITimekitComponent } from '../timekit-tabs/timekit-tabs.component';
import {  ThemingService } from 'src/app/theming.service';
import { SettingsService } from 'src/app/settings.service';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-timekit-schedule',
  templateUrl: './timekit-schedule.component.html',
  styleUrls: ['./timekit-schedule.component.scss']
})

export class TimekitScheduleComponent implements ITimekitComponent {
  @Input() data: any;
    listingAppointments = true;
    listingCreateAppointment = true;
    activeTab: 'resource' | 'projects' = 'resource';

    constructor(
      public themingService: ThemingService,
      private settingsService: SettingsService,
    ) {}

    ngOnInit(): void {}

    setActiveTab(tab: 'resource' | 'projects') {
      this.activeTab = tab;
    }

    getListingAppointments(): boolean {
      return this.settingsService.getListingAppointments();
    }

    getListingCreateAppointment(): boolean {
      return this.settingsService.getListingCreateAppointment();
    }
  }
